import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=584c65b3&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('584c65b3')) {
      api.createRecord('584c65b3', component.options)
    } else {
      api.reload('584c65b3', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=584c65b3&", function () {
      api.rerender('584c65b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BnMwcmWGIpFp/JS/comp/FavElement.vue"
export default component.exports